import * as React from 'react';
import { Search } from './search';
import { AddButton } from './add-button';
import { ISearchLocation, IElementDictionary, EComponentTypes, EModalType, DOMHelper } from '../../helpers';
import { Modal } from '../../components';
import store from '../../store/store';
import types from '../../store/types';
import { DialogType } from 'office-ui-fabric-react';
import { SearchGrid } from './SearchGrid';


interface IProps {
    searchTerm: string;
    showResultsWithEmptyTerm: boolean;
    labelText: string;
    results: IElementDictionary;
    awaitingResults: boolean;
    debounceDelay: number;
    isCurrentSearchComponent: boolean;
    updateResults: (searchTerm: string, passedSubmissionComponent?: boolean) => void;
    onResultClick: (key: string, item: JSX.Element) => void;
    searchLocation: ISearchLocation;
    setSearchLocation: (id: any, elementId: string, passedSubmissionComponent?: boolean) => void;
    element: any;
    inBranch?: boolean;
    inLoop?: boolean;
    search: boolean;
    passedSubmissionComponent: boolean;
    setNextComponentId?: (elementId: string, componentId: string, nextComponentId: string, elementType: string) => any;
    toggleNewComponentDialog?: () => void;

}

export class SearchWrapper extends React.Component<IProps, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            style: { display: 'none' }
        }
        this.setStyle = this.setStyle.bind(this);

    }

    setStyle(val: React.CSSProperties) {
        this.setState({
            style: val
        });
    }


    private blur = (e?) => {

        if (!this.props.search)
            return;

        setTimeout(() => {
            this.props.setSearchLocation(null, null);
        }, 0);

    }

    // set active branch on div click
    setActiveBranch = (element) => {
        let nextComponentId = element.elementId;
        let elementId = element.componentId + '_SELECTOR';
        let componentId = element.componentId;
        let type = 'BranchSelector';
        this.props.setNextComponentId(
            elementId,
            componentId,
            nextComponentId,
            type
        );

    }

    dismissDialog = () => {

        let { openModal } = store.getState().modalState.modal;
        let { outputs } = store.getState().outputsState.globalOutputs;

        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

        if (openModal === EModalType.GlobalOutputs)
            store.dispatch({ type: types.SET_GLOBAL_OUTPUTS_STATE, outputs: outputs });
    }

    dismissErrorMessage = () => {
        store.dispatch({
            type: types.SET_ERROR_MESSAGE_DISMISSED,
            errorMessageDismissed: true
        });

    }

    componentDidMount() {
        this.blur();
    }

    // componentDidUpdate(prevProps) {

    //     if (store.getState().modalState.modal && prevProps.state.modal &&
    //         prevProps.state.modal.openModal === EModalType.None && store.getState().modalState.modal.openModal !== EModalType.None) {

    //         DOMHelper.setDialogHeight();

    //     }

    // }


    public render() {
        let { openModal, errorMessages, warningMessages, errorMessageDismissed, overlayMessage } = store.getState().modalState.modal;
        let childElement: JSX.Element;
        let title: string = '';

        let {
            results, searchTerm, awaitingResults, isCurrentSearchComponent, onResultClick, showResultsWithEmptyTerm, labelText, debounceDelay, updateResults,
            searchLocation, setSearchLocation, element, inBranch, search, passedSubmissionComponent, toggleNewComponentDialog
        } = this.props;
        let classNames: string[] = ['btn-component', 'component', 'ui-only'];

        if (inBranch)
            classNames.push('in-branch');

        //render nothing for this component if the searchLocation is for a Summary component
        let hideWholeComponent: boolean = searchLocation.ComponentType && (searchLocation.ComponentType.ComponentTypeId === EComponentTypes.summary || searchLocation.ComponentType.ComponentTypeId === EComponentTypes.redirect);

        // render div with click event to change state if the component is right after branch selector
        let isNextToBranchSelector = this.props.element.elementId.slice(-3) === 'ADD';

        return (
            hideWholeComponent ?
                null :
                isNextToBranchSelector ?
                    <div className={classNames.join(' ')} onBlur={this.blur} onClick={() => this.setActiveBranch(element)}>

                        {search ?
                            <div>
                                <Modal title={'Add New Component'}
                                    isOpen={openModal === EModalType.AddComponent}
                                    onDismiss={() => {
                                        openModal === EModalType.AuthenticationWarning ? null : this.dismissDialog();
                                        this.blur()
                                    }}
                                    errorMessages={errorMessageDismissed ? [] : errorMessages}
                                    warningMessages={errorMessageDismissed ? [] : warningMessages}
                                    overlayMessage={overlayMessage}
                                    dismissErrorMessage={this.dismissErrorMessage}
                                    type={openModal === EModalType.AuthenticationWarning ? DialogType.normal : null}

                                    // Do not block other events since TinyMCE floatpanels needs to be clickable 
                                    isBlocking={true}>
                                    <SearchGrid
                                        debounceDelay={debounceDelay}
                                        awaitingResults={awaitingResults}
                                        onResultClick={onResultClick}
                                        results={results}
                                        searchTerm={searchTerm}
                                        labelText={labelText}
                                        showResultsWithEmptyTerm={showResultsWithEmptyTerm}
                                        isCurrentSearchComponent={isCurrentSearchComponent}
                                        updateResults={updateResults}
                                        passedSubmissionComponent={passedSubmissionComponent} />

                                </Modal>
                                <AddButton
                                    searchLocation={searchLocation}
                                    setSearchLocation={setSearchLocation}
                                    element={element}
                                    passedSubmissionComponent={passedSubmissionComponent}
                                    toggleNewComponentDialog={toggleNewComponentDialog}
                                />
                            </div>

                            : <AddButton
                                searchLocation={searchLocation}
                                setSearchLocation={setSearchLocation}
                                element={element}
                                passedSubmissionComponent={passedSubmissionComponent}
                                toggleNewComponentDialog={toggleNewComponentDialog} />}

                    </div>
                    :
                    <div className={classNames.join(' ')} onBlur={this.blur}
                    // onMouseEnter={e => {
                    //     this.setStyle({ display: 'block' });
                    // }}
                    // onMouseLeave={e => {
                    //     this.setStyle({ display: 'none' })
                    // }}
                    >

                        {search ?
                            // null
                            <div>
                                <Modal title={'Add New Component'}
                                    isOpen={openModal === EModalType.AddComponent}
                                    onDismiss={() => {
                                        openModal === EModalType.AuthenticationWarning ? null : this.dismissDialog();
                                        this.blur()
                                    }}
                                    errorMessages={errorMessageDismissed ? [] : errorMessages}
                                    warningMessages={errorMessageDismissed ? [] : warningMessages}
                                    overlayMessage={overlayMessage}
                                    dismissErrorMessage={this.dismissErrorMessage}
                                    type={openModal === EModalType.AuthenticationWarning ? DialogType.normal : null}

                                    // Do not block other events since TinyMCE floatpanels needs to be clickable 
                                    isBlocking={true}>
                                    < SearchGrid
                                        debounceDelay={debounceDelay}
                                        awaitingResults={awaitingResults}
                                        onResultClick={onResultClick}
                                        results={results}
                                        searchTerm={searchTerm}
                                        labelText={labelText}
                                        showResultsWithEmptyTerm={showResultsWithEmptyTerm}
                                        isCurrentSearchComponent={isCurrentSearchComponent}
                                        updateResults={updateResults}
                                        passedSubmissionComponent={passedSubmissionComponent} />
                                </Modal>
                                <AddButton
                                    searchLocation={searchLocation}
                                    setSearchLocation={setSearchLocation}
                                    element={element}
                                    passedSubmissionComponent={passedSubmissionComponent}
                                    toggleNewComponentDialog={toggleNewComponentDialog}
                                />
                            </div>
                            // < Search
                            //     debounceDelay={debounceDelay}
                            //     awaitingResults={awaitingResults}
                            //     onResultClick={onResultClick}
                            //     results={results}
                            //     searchTerm={searchTerm}
                            //     labelText={labelText}
                            //     showResultsWithEmptyTerm={showResultsWithEmptyTerm}
                            //     isCurrentSearchComponent={isCurrentSearchComponent}
                            //     updateResults={updateResults}
                            //     passedSubmissionComponent={passedSubmissionComponent} />
                            : <AddButton
                                searchLocation={searchLocation}
                                setSearchLocation={setSearchLocation}
                                element={element}
                                passedSubmissionComponent={passedSubmissionComponent}
                                toggleNewComponentDialog={toggleNewComponentDialog}

                            />}

                    </div>

        );
    }
}



// WEBPACK FOOTER //
// ./source/ts/components/search/search-wrapper.tsx